import React, { Component } from 'react'
import './calendarRowMonth.scss'

class CalendarRowMonth extends Component {
  constructor (props) {
    super(props)

    this.state = {
    }
  }

  renderRowColumn (column, key) {
    let classNames = 'calendar-row-month__column'
    if (column.IsClosed) {
      classNames += ' closed'
    }

    return (
      <div className={classNames} key={key} />
    )
  }

  render () {
    const { rowColumns, children, orderInfo } = this.props

    const contentStyle = {}
    if (rowColumns && rowColumns.length > 0) {
      contentStyle.gridTemplateColumns = `repeat(${rowColumns.length}, minmax(16px, 1fr))`
    }

    return (
      <div className='calendar-row-month'>
        <div className='calendar-row-month__info'>
          {orderInfo}
        </div>
        <div className='calendar-row-month__content' style={contentStyle}>
          <div className='calendar-row-month__items'>{children}</div>
          {rowColumns.map(this.renderRowColumn)}
        </div>
      </div>
    )
  }
}

export default CalendarRowMonth



// WEBPACK FOOTER //
// ./src/app/shared/components/Calendar/calendarRowMonth/index.js